import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';
import { isEmpty } from 'mojito/utils';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

const { FlexPane, ToggleButton, Image } = MojitoPresentation.Components;
const { useAnalyticsContext } = MojitoCore.Presentation.Hooks;

const {
    selectors: { selectIsEventEligible, selectIsEventSubscribed, selectIsServiceAvailable },
    actions,
} = MojitoServices.SportsContent.ContentNotifications;

const SubscribeEventsToggle = ({
    eventIds,
    hideBellIcon,
    l10nKeyLabel,
    mojitoTools: { config, stringResolver, appContext },
}) => {
    const dispatch = useDispatch();
    const isServiceAvailable = useSelector(selectIsServiceAvailable);
    const eligibleEventIds = useSelector(
        state => eventIds.filter(id => selectIsEventEligible(id, state)),
        shallowEqual
    );
    const isEveryEventSubscribed = useSelector(
        state =>
            eligibleEventIds.length > 0 &&
            eligibleEventIds.every(eventId => selectIsEventSubscribed(eventId, state))
    );

    const { analyticsPath } = useAnalyticsContext();
    const onToggle = () => {
        dispatch(
            isEveryEventSubscribed
                ? actions.unfollowEvents(eventIds)
                : actions.followEvents(eventIds)
        );
        const { emitAnalytics } = appContext.analyticsEmitter;
        emitAnalytics('toggleNotifications', {
            source: analyticsPath,
            value: !isEveryEventSubscribed,
        });
    };

    if (!isServiceAvailable || isEmpty(eligibleEventIds)) {
        return null;
    }

    return (
        <FlexPane class="ta-SubscribeEventsToggle" config={config.container}>
            {!hideBellIcon && <Image class="ta-bellIcon" config={config.bellIcon} />}
            <ToggleButton
                config={config.toggleButton}
                class="ta-subscribeToggleButton"
                value={isEveryEventSubscribed}
                onToggle={onToggle}
                label={stringResolver.resolveString(l10nKeyLabel)}
            />
        </FlexPane>
    );
};

export default SubscribeEventsToggle;
